import { render, staticRenderFns } from "./PPortPath.vue?vue&type=template&id=406ee23e&scoped=true"
import script from "./PPortPath.vue?vue&type=script&lang=js"
export * from "./PPortPath.vue?vue&type=script&lang=js"
import style0 from "./PPortPath.vue?vue&type=style&index=0&id=406ee23e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406ee23e",
  null
  
)

export default component.exports